import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CMS } from '../../utils/CMS';
import { Checkbox } from '../../components/Checkbox';
import { ResidentDiscountInfo } from './ResidentDiscountInfo';

export const ResidentDiscountCheckbox = ({
    checked,
    hasNonAdults,
    onChange,
    regionsText,
    showInfo,
}) => {
    const [isOpen, setOpen] = React.useState(false);
    const checkboxProps = {
        id: 'selectable-checkbox-resident-discount',
        checked,
        disabled: hasNonAdults,
        onChange,
    };

    const toggle = (toState = null) => {
        setOpen(typeof toState === 'boolean' ? toState : !isOpen);
    };

    const stopPropagation = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const infoClassNames = classNames({
        'odf-tooltip-container odf-text-info odf-space-inner-left-xs': true,
        'open': isOpen,
    });

    return (
        <Checkbox {...checkboxProps}>
            <span>
                <CMS id="flightsManager.residentDiscount.residentall" dangerouslySetInnerHTML />
                <span style={{ whiteSpace: 'nowrap' }}>
                    {regionsText}
                    {showInfo && (
                        <span
                            className={infoClassNames}
                            onMouseEnter={toggle}
                            onMouseLeave={toggle}
                            onClick={stopPropagation}
                        >
                            <span className="odf-icon odf-icon-information odf-clickable" />
                            <div
                                className="odf-tooltip odf-tooltip-plain odf-tooltip-bottom-center odf-space-inner-s"
                                style={{ width: '350px', whiteSpace: 'initial', cursor: 'auto' }}
                            >
                                <ResidentDiscountInfo hasNonAdults={hasNonAdults} />
                            </div>
                        </span>
                    )}
                </span>
            </span>
        </Checkbox>
    );
};

ResidentDiscountCheckbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    hasNonAdults: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    regionsText: PropTypes.string.isRequired,
    showInfo: PropTypes.bool,
};

ResidentDiscountCheckbox.defaultProps = {
    showInfo: false,
};
